import { sortBy } from "lodash";

import { ComplianceProgramActionBasicItemProps } from "../helpers";

export function sortByCompletedItemsLast<
  T extends ComplianceProgramActionBasicItemProps,
>(items: T[]): T[] {
  // Open tasks first, then tasks that cannot be opened yet, then completed ones.
  return sortBy(items, (item) => {
    return item.statusCompleted ? 2 : item.blocked ? 1 : 0;
  });
}
